import {getValueByDevice, useDevice} from 'platform/foundation';

export function useIsCardExpandable() {
  const device = useDevice();
  return getValueByDevice(device, true, true, true, false);
}
